import { useEffect, useContext } from 'react';
import MountedContext from './MountedContext';

var useHasMounted = function useHasMounted() {
  var _useContext = useContext(MountedContext),
      hasMounted = _useContext.hasMounted,
      setHasMounted = _useContext.setHasMounted;

  useEffect(function () {
    if (!hasMounted) {
      setHasMounted(true);
    }
  }, []);
  return hasMounted;
};

export default useHasMounted;